import { isUsernameAvailable } from '@db/Users/Check';
import { logError } from '@helpers/Loggers';

export type UserDisplayNameParts = {
  firstName: string;
  lastName: string;
};

export function joinUserDisplayName({ firstName, lastName }: UserDisplayNameParts) {
  return [firstName.trim(), lastName.trim()].filter(Boolean).join(' ');
}

export function splitUserDisplayName(displayName: string): UserDisplayNameParts {
  const [firstName = '', ...lastNameParts] = displayName.trim().split(/\s+/);
  return {
    firstName,
    lastName: lastNameParts.join(' '),
  };
}

export function validateUserDisplayName(name: string) {
  if (!name.trim()) return "Name can't be empty.";
  if (/\d/.test(name)) return "Name can't include numbers.";
  return '';
}

export async function validateUsername(username: string) {
  const re = /^(?=[a-zA-Z0-9._]{4,20}$)(?!.*[_.]{2})[^_.].*[^_.]$/;
  if (!username) return "Username can't be empty.";
  if (!re.test(username)) return 'Username is invalid.';
  try {
    const available = await isUsernameAvailable(username);
    if (!available) {
      return 'Username already in use.';
    }
  } catch (error) {
    logError(error);
    return 'An error occurred, please try again.';
  }
  return '';
}

export function validateUserBirthdate(birthdate: Date) {
  if (!birthdate) return 'Please provide a valid date.';
  if (isNaN(birthdate.getTime())) return 'Please provide a valid date.';
  const now = new Date(Date.now());
  if (birthdate >= now) return 'Birthdate must be in the past.';
  return '';
}
